export default function InfoRowData({
  registerId,
  leftField,
  rightField,
  maxHeightValue,
}) {
  return (
    <div key={registerId} className="flex report_internal_field">
      <div
        key={`${registerId}-0`}
        className="flex"
        style={{
          width: rightField ? '50%' : '100%',
          gap: '5px',
          alignContent: 'center',
        }}
      >
        {leftField.Name?.length > 0 && (
          <div key={`${registerId}-1`}>
            <label className="report_little_text">
              <b>{leftField.Name}</b>
            </label>
          </div>
        )}
        <div
          key={`${registerId}-2`}
          style={
            maxHeightValue
              ? { maxHeight: maxHeightValue, overflow: 'clip' }
              : { overflow: 'clip' }
          }
        >
          <label
            style={{ textOverflow: 'clip', overflow: 'clip' }}
            className="report_little_text"
          >
            {leftField.Value}
          </label>
        </div>
      </div>

      {rightField && (
        <div
          key={`${registerId}-3`}
          className="flex"
          style={{
            width: '50%',
            gap: '5px',
            paddingRight: '10px',
          }}
        >
          <div key={`${registerId}-4`}>
            <label className="report_little_text">
              <b>{rightField.Name}</b>
            </label>
          </div>
          <div
            key={`${registerId}-5`}
            style={{ maxHeight: maxHeightValue ?? '25px', overflow: 'clip' }}
          >
            <label
              style={{ textOverflow: 'clip', overflow: 'clip' }}
              className="report_little_text"
            >
              {rightField.Value}
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
